import { Slide, ToastContainer } from 'react-toastify';
import { AuthProvider } from './components/context/authContext';
import AllRoutes from './components/routes/routes';
import "./components/common/common.css"
import { LoaderProvider } from './components/context/loaderContext';

function App() {
  return (
    <>
      <LoaderProvider>
        <AuthProvider>
          <AllRoutes />
        </AuthProvider>
      </LoaderProvider>
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Slide}
      />
    </>
  );
}

export default App;
